import { render, staticRenderFns } from "./RuleCustomListOrder.vue?vue&type=template&id=c440a9ea&scoped=true"
import script from "./RuleCustomListOrder.vue?vue&type=script&lang=js"
export * from "./RuleCustomListOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c440a9ea",
  null
  
)

export default component.exports